/**
 * Canonical status-to-label mapping for application statuses.
 * Single source of truth — used by both server and client.
 */
export const STATUS_LABELS: Record<string, string> = {
  applied: "Inscrito",
  prioritized: "Priorizado",
  deprioritized: "Despriorizado",
  interviewing: "Em Entrevista",
  reference_checks: "Reference Checks",
  dossier: "Committee",
  offer: "Oferta",
  hired: "Contratado",
  rejected: "Rejeitado",
  offer_rejected: "Offer Rejected",
};

/** Fixed statuses that appear before interview stages in the pipeline. */
export const PRE_INTERVIEW_STATUSES = ["applied", "prioritized", "deprioritized"] as const;

/** Fixed statuses that appear after interview stages in the pipeline. */
export const POST_INTERVIEW_STATUSES = [
  "reference_checks",
  "dossier",
  "offer",
  "hired",
  "rejected",
  "offer_rejected",
] as const;

/**
 * Full pipeline order for the stages dimension.
 * Interview stages (dynamic, from DB) are inserted between pre and post.
 */
export function buildPipelineOrder(
  interviewStages: Array<{ stageName: string; stageOrder: number }>,
): Map<string, number> {
  const orderMap = new Map<string, number>();
  let pos = 0;

  for (const status of PRE_INTERVIEW_STATUSES) {
    orderMap.set(STATUS_LABELS[status], pos++);
  }
  // "Em Entrevista" (interviewing without a stage) sorts just before the first interview stage
  orderMap.set(STATUS_LABELS.interviewing, pos++);
  for (const stage of [...interviewStages].sort((a, b) => a.stageOrder - b.stageOrder)) {
    orderMap.set(stage.stageName, pos++);
  }
  for (const status of POST_INTERVIEW_STATUSES) {
    orderMap.set(STATUS_LABELS[status], pos++);
  }

  return orderMap;
}
